import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import CircleAddIcon from "../../img/svg/circule-add.svg";
import LeftArrowLightIcon from "../../img/svg/Left_arrow_light.svg";
import "../../styles/multipleEntryPass.scss";

const MultipleEntryPassAdd = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <div
      className="multiple-entry-pass__item multiple-entry-pass__item--add-new"
      onClick={onClick}
    >
      <div className="multiple-entry-pass__icon">
        <img src={CircleAddIcon} alt="Add" />
      </div>
      <div className="multiple-entry-pass__content">
        <Typography className="multiple-entry-pass__title">
          {t("PURCHASE_NEW_MULTIPLE_ENTRY_PASS")}
        </Typography>
      </div>
      <img
        src={LeftArrowLightIcon}
        alt="Arrow"
        className="multiple-entry-pass__arrow"
      />
    </div>
  );
};

export default MultipleEntryPassAdd;
